import { ArrowLeft, History, Radar } from "lucide-react";

export const SearchConsole = ({ keywords, onSearch, searching, onHistory, onBack }) =>
  <div className="search-quick-actions" data-testid="el-sabueso-panel">
    <button type="button" className="search-tool" onClick={onBack} title="Modifica area"
      data-testid="search-back-to-area"><ArrowLeft size={19} aria-hidden="true" /><span>Area</span></button>
    <button type="button" className="search-tool icon-only" onClick={onHistory} title="Storico ricerche"
      aria-label="Storico ricerche" data-testid="search-history-open"><History size={21} aria-hidden="true" /></button>
    <button type="button" className="hud-button search-launch" disabled={searching || !keywords.length}
      onClick={onSearch} data-testid="search-launch-button"><Radar size={19} aria-hidden="true" /><span>Lancia ricerca</span></button>
  </div>;